export default __webpack_public_path__ + "static/media/blue-divider-bottom.8b323909.svg";